import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './infographic-page-center.component.scss';
var InfographicPageCenter = /** @class */ (function (_super) {
    tslib_1.__extends(InfographicPageCenter, _super);
    function InfographicPageCenter(element) {
        return _super.call(this, element) || this;
    }
    InfographicPageCenter.prototype.init = function () { };
    InfographicPageCenter.prototype.bindEvents = function () { };
    return InfographicPageCenter;
}(Base));
export { InfographicPageCenter };



//////////////////
// WEBPACK FOOTER
// ./components/infographic-page-center/infographic-page-center.component.ts
// module id = 386
// module chunks = 0